<p class="description">{{ "settings.customization.generalDesignDescription" | translate }}</p>

@for (brandVariable of brandVariables | keyvalue: keyDescOrder; track brandVariable) {
  <div class="brand-variable-wrapper" [ngClass]="{ 'page-templates': isBrandVarPageForTemplatePage }">
    <p class="brand-variable-name">{{ "settings.customization.brand-settings.variables." + brandVariable.key | translate }}</p>
    <div class="color-font-variables-items-wrapper var-row">
      @if (brandVariable.value.textProperties) {
        <div class="font-variable-item">
          <div class="brand-variable-item-title">{{ "campaign.widget.sidebar.edit.expansionPanelTitle.text" | translate }}:</div>
          <div
            class="font-picker"
            [style.font-family]="displayFontNames[brandVariable.key]?.name"
            [matMenuTriggerFor]="fontPicker"
            #menuFontTrigger="matMenuTrigger">
            <span>{{ displayFontNames[brandVariable.key]?.displayName }}</span>
            <mat-icon>arrow_drop_down</mat-icon>
          </div>
          <mat-menu #fontPicker="matMenu" class="font-picker-menu" (closed)="onMenuFontClosed(brandVariable.value.textProperties)">
            <div mat-menu-item class="wrapper-font-picker" [disableRipple]="true" (click)="closeFontMenu($event)">
              <app-font-menu
                [customFonts]="customFonts"
                [defaultFonts]="defaultFonts"
                (openFontFamilyFlyout)="openFontFamilyFlyout()"
                [brandVariablesErrorsVar]="brandVariablesErrors[brandVariable.key]"
                [setTextProperties]="brandVariable.value.textProperties"
                [typeVariable]="brandVariable.key"
                (emitUpdatesFontOnBrandVariables)="emitUpdatesFontOnBrandVariables($event)"></app-font-menu>
            </div>
          </mat-menu>
        </div>
      }
      <!-- color variable -->
      @if (brandVariable.value.color || brandVariable.value.color === "") {
        <div class="color-variable-item">
          <p class="color-picker-button rectangular" [style.backgroundColor]="brandVariable.value?.color" [matMenuTriggerFor]="colorPickerBrandVariable"></p>
          <mat-menu
            #colorPickerBrandVariable="matMenu"
            class="colors-menu-modal"
            (closed)="validateColorBrandVariables(brandVariable?.value.color, brandVariable.key, BrandVarEntity.Color)">
            <div mat-menu-item class="wrapper-color-picker" [disableRipple]="true">
              <app-color-picker
                (click)="closeColorMenu($event)"
                [inputAccountColors]="accountColors"
                [currentColor]="brandVariable.value?.color"
                (customColorUpdated)="changeOnColorPickerBrandVariable($event, brandVariable.value, BrandVarEntity.Color, brandVariable.key)"
                (enterInput)="closeColorMenu()"
                [firstTab]="countOpenMenu"></app-color-picker>
            </div>
          </mat-menu>
          <div class="value-color-field variable-field">
            <mat-form-field appearance="outline">
              <input
                matInput
                type="text"
                [(ngModel)]="brandVariable.value.color"
                (input)="validateColorBrandVariables(brandVariable?.value?.color, brandVariable.key, BrandVarEntity.Color)"
                placeholder="{{ 'settings.customization.colors.color' | translate }}" />
            </mat-form-field>
            @if (brandVariablesErrors[brandVariable.key]?.color) {
              <mat-hint
                class="error"
                [ngClass]="
                  brandVariable.key === 'headline' ||
                  brandVariable.key === 'text' ||
                  brandVariable.key === 'button' ||
                  brandVariable.key === 'input' ||
                  brandVariable.key === 'label'
                    ? 'color'
                    : ''
                ">
                * {{ brandVariablesErrors[brandVariable.key]?.color }}
              </mat-hint>
            }
          </div>
        </div>
      }
    </div>
    <!-- radius variable -->
    @if (brandVariable.value?.radius || $safeNavigationMigration(brandVariable.value?.radius) === null) {
      <div class="radius-variable-item value-text-field var-row">
        <p class="brand-variable-item-title">{{ "settings.customization.brand-settings.variables.radius" | translate }}:</p>
        <div class="input-field">
          <mat-form-field class="small-input-field" appearance="outline" floatLabel="auto">
            <input
              matInput
              [(ngModel)]="brandVariable.value.radius.roundValue"
              type="number"
              min="0"
              (input)="validateBrandVariables(brandVariable.value.radius?.roundValue, brandVariable.key, 'radius')" />
          </mat-form-field>
          &nbsp;&nbsp;px
          @if (brandVariablesErrors[brandVariable.key]?.radius) {
            <mat-hint class="error">* {{ brandVariablesErrors[brandVariable.key].radius }}</mat-hint>
          }
        </div>
      </div>
    }
    <!-- background variable -->
    @if (brandVariable.value?.backgroundColor || brandVariable.value?.backgroundColor === "") {
      <div class="background-variable-item var-row">
        <p class="brand-variable-item-title">{{ "settings.customization.brand-settings.variables.backgroundColor" | translate }}:</p>
        <p
          class="color-picker-button rectangular"
          [style.backgroundColor]="brandVariable.value?.backgroundColor"
          [matMenuTriggerFor]="backGroundPickerBrandVariable"></p>
        <mat-menu
          #backGroundPickerBrandVariable="matMenu"
          class="colors-menu-modal"
          (closed)="validateColorBrandVariables(brandVariable.value?.backgroundColor, brandVariable.key, BrandVarEntity.BackgroundColor)">
          <div mat-menu-item class="wrapper-color-picker" [disableRipple]="true">
            <app-color-picker
              (click)="closeColorMenu($event)"
              [inputAccountColors]="accountColors"
              [currentColor]="brandVariable.value?.backgroundColor"
              (customColorUpdated)="changeOnColorPickerBrandVariable($event, brandVariable.value, BrandVarEntity.BackgroundColor, brandVariable.key)"
              (enterInput)="closeColorMenu()"
              [firstTab]="countOpenMenu"></app-color-picker>
          </div>
        </mat-menu>
        <div class="value-color-field variable-field">
          <mat-form-field appearance="outline">
            <input
              matInput
              type="text"
              [(ngModel)]="brandVariable.value.backgroundColor"
              (input)="validateColorBrandVariables(brandVariable.value.backgroundColor, brandVariable.key, BrandVarEntity.BackgroundColor)"
              placeholder="{{ 'settings.customization.colors.color' | translate }}" />
          </mat-form-field>
          @if (brandVariablesErrors[brandVariable.key].backgroundColor) {
            <mat-hint
              class="error"
              [ngClass]="brandVariable.key !== 'canvas' && brandVariable.key !== 'button' && brandVariable.key !== 'input' ? 'color' : ''">
              * {{ brandVariablesErrors[brandVariable.key].backgroundColor }}
            </mat-hint>
          }
        </div>
      </div>
    }
    <!-- close button color variable -->
    @if (brandVariable.value.closeButtonColor || brandVariable.value.closeButtonColor === "") {
      <div class="background-variable-item var-row">
        <p class="brand-variable-item-title">{{ "settings.customization.brand-settings.variables.closeButtonColor" | translate }}:</p>
        <p
          class="color-picker-button rectangular"
          [style.backgroundColor]="brandVariable.value?.closeButtonColor"
          [matMenuTriggerFor]="closeButtonPickerBrandVariable"></p>
        <mat-menu
          #closeButtonPickerBrandVariable="matMenu"
          class="colors-menu-modal"
          (closed)="validateColorBrandVariables(brandVariable.value.closeButtonColor, brandVariable.key, BrandVarEntity.CloseButtonColor)">
          <div mat-menu-item class="wrapper-color-picker" [disableRipple]="true">
            <app-color-picker
              (click)="closeColorMenu($event)"
              [inputAccountColors]="accountColors"
              [currentColor]="brandVariable.value?.closeButtonColor"
              (customColorUpdated)="changeOnColorPickerBrandVariable($event, brandVariable.value, BrandVarEntity.CloseButtonColor, brandVariable.key)"
              (enterInput)="closeColorMenu()"
              [firstTab]="countOpenMenu"></app-color-picker>
          </div>
        </mat-menu>
        <div class="value-color-field variable-field">
          <mat-form-field appearance="outline">
            <input
              matInput
              type="text"
              [(ngModel)]="brandVariable.value.closeButtonColor"
              (input)="validateColorBrandVariables(brandVariable.value.closeButtonColor, brandVariable.key, BrandVarEntity.CloseButtonColor)"
              placeholder="{{ 'settings.customization.colors.color' | translate }}" />
          </mat-form-field>
          @if (brandVariablesErrors[brandVariable.key].closeButtonColor) {
            <mat-hint class="error" [ngClass]="brandVariable.key !== 'canvas' ? 'color' : ''">
              * {{ brandVariablesErrors[brandVariable.key].closeButtonColor }}
            </mat-hint>
          }
        </div>
      </div>
    }
    <!-- border -->
    @if (brandVariable.value.border || brandVariable.value.border === null) {
      <div class="var-row">
        <mat-checkbox class="sidebar-edit-checkbox" [(ngModel)]="isBorderSet" (change)="toggleBorderSetting(brandVariable.value, brandVariable.key)">
          <div class="sidebar-edit-item-text">{{ "campaign.widget.sidebar.edit.appearance.border" | translate }}</div>
        </mat-checkbox>
        <!-- border-width -->
        @if (isBorderSet) {
          <div class="border-variable-item value-text-field var-row">
            <p class="brand-variable-item-title">{{ "generic.size" | translate }}:</p>
            <div class="input-field">
              <mat-form-field class="small-input-field" appearance="outline" floatLabel="auto">
                <input
                  matInput
                  [(ngModel)]="brandVariable.value.border.width"
                  type="number"
                  min="0"
                  (input)="validateBrandVariables(brandVariable.value.border.width, brandVariable.key, BrandVarEntity.Border, BrandVarEntity.Width)" />
              </mat-form-field>
              &nbsp;&nbsp;px
              @if (brandVariablesErrors[brandVariable.key].border.width) {
                <mat-hint class="error">* {{ brandVariablesErrors[brandVariable.key].border.width }}</mat-hint>
              }
            </div>
          </div>
        }
        <!-- border color -->
        @if (isBorderSet) {
          <div class="background-variable-item border-variable-item var-row">
            <p class="brand-variable-item-title">{{ "campaign.widget.sidebar.edit.appearance.color" | translate }}:</p>
            <p
              class="color-picker-button rectangular"
              [style.backgroundColor]="brandVariable.value?.border.color"
              [matMenuTriggerFor]="borderColorPickerBrandVariable"></p>
            <mat-menu
              #borderColorPickerBrandVariable="matMenu"
              class="colors-menu-modal"
              (closed)="validateColorBrandVariables(brandVariable.value.border.color, brandVariable.key, BrandVarEntity.BorderColor)">
              <div mat-menu-item class="wrapper-color-picker" [disableRipple]="true">
                <app-color-picker
                  (click)="closeColorMenu($event)"
                  [inputAccountColors]="accountColors"
                  [currentColor]="brandVariable.value?.border.color"
                  (customColorUpdated)="
                    changeOnColorPickerBrandVariable($event, brandVariable.value.border, BrandVarEntity.Border, brandVariable.key, BrandVarEntity.Color)
                  "
                  (enterInput)="closeColorMenu()"
                  [firstTab]="countOpenMenu"></app-color-picker>
              </div>
            </mat-menu>
            <div class="value-color-field variable-field">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  type="text"
                  [(ngModel)]="brandVariable.value.border.color"
                  (input)="validateColorBrandVariables(brandVariable.value.border.color, brandVariable.key, BrandVarEntity.Border, BrandVarEntity.Color)"
                  placeholder="{{ 'settings.customization.colors.color' | translate }}" />
              </mat-form-field>
              @if (brandVariablesErrors[brandVariable.key].border.color) {
                <mat-hint class="error">* {{ brandVariablesErrors[brandVariable.key].border.color }}</mat-hint>
              }
            </div>
          </div>
        }
      </div>
    }
    <!-- padding -->
    @if (brandVariable.value?.padding || brandVariable.value.padding === null) {
      <div class="value-text-field var-row">
        <app-margin-padding
          [setComponent]="{ component: brandVariable.value, nameProp: 'padding' }"
          [isCheckBox]="true"
          [customClass]="'branding'"
          (emitUpdatesOnComponent)="emitUpdatesOnComponent()"></app-margin-padding>
      </div>
    }
    <!-- margin -->
    @if (brandVariable.value?.margin || brandVariable.value.margin === null) {
      <div class="value-text-field var-row">
        <app-margin-padding
          [setComponent]="{ component: brandVariable.value, nameProp: 'margin' }"
          [isCheckBox]="true"
          [customClass]="'branding'"
          (emitUpdatesOnComponent)="emitUpdatesOnComponent()"></app-margin-padding>
      </div>
    }
    <!-- height -->
    @if (brandVariable.value?.height || brandVariable.value.height === null || brandVariable.value.height === 0) {
      <div class="height-variable-item value-text-field var-row">
        <p class="brand-variable-item-title">{{ "generic.height" | translate }}:</p>
        <div class="input-field">
          <mat-form-field class="small-input-field" appearance="outline" floatLabel="auto">
            <input
              matInput
              [(ngModel)]="brandVariable.value.height"
              type="number"
              min="0"
              (input)="validateBrandVariables(brandVariable.value.height, brandVariable.key, 'height')" />
          </mat-form-field>
          &nbsp;&nbsp;px
          @if (brandVariablesErrors[brandVariable.key].height) {
            <mat-hint class="error">* {{ brandVariablesErrors[brandVariable.key].height }}</mat-hint>
          }
        </div>
      </div>
    }
    <!-- text alignment -->
    @if (brandVariable.value.alignment || brandVariable.value.alignment === null) {
      <div class="value-text-field var-row">
        <app-alignment
          [customClass]="'branding'"
          [setComponent]="{ component: brandVariable.value }"
          (emitUpdatesOnComponent)="emitUpdatesOnComponent()"></app-alignment>
      </div>
    }
  </div>
}
@if (isAutomaticallyGenerated) {
  <div class="automatically-generated-msg">{{ "settings.customization.brand-settings.auto-info" | translate }}</div>
}
